import Vue from 'vue'
import {mapGetters} from 'vuex'

import template from './_municipality-selector.pug'

// @vue/component
export default Vue.extend({
  template: template()
})
